// fixes an issue with browsers offsetting the timezone to local time causing date to render as previous day

const getDateWithOffset = (date: Date) => {
  return (date?.valueOf() || 0) + (date?.getTimezoneOffset() || 0) * 60 * 1000;
};

export default getDateWithOffset;
